module.exports = __webpack_public_path__ + "static/Clearmind_Exxes-9572864bb5cdf50910fd312903642c69.gif";